module.exports = __webpack_public_path__ + "autoalert-logo.ee44a6f4770cf0a1851d.png";